export const START_PENDING_INVITE_STORAGE_KEY = "wizmate.start.pending-invite.v1";

export type PendingStartInvite = {
  inviteCode: string;
  createdAt: string;
  sourcePath: string;
};

function getSessionStorage(): Storage | null {
  try {
    if (typeof window === "undefined") return null;
    return window.sessionStorage ?? null;
  } catch {
    return null;
  }
}

function normalizeInviteCode(value: string | null | undefined): string | null {
  const trimmed = value?.trim() ?? "";
  return trimmed ? trimmed : null;
}

export function writePendingStartInvite(params: {
  inviteCode: string;
  sourcePath: string;
  createdAt?: string;
}): PendingStartInvite | null {
  const inviteCode = normalizeInviteCode(params.inviteCode);
  if (!inviteCode) return null;

  const snapshot: PendingStartInvite = {
    inviteCode,
    createdAt: params.createdAt ?? new Date().toISOString(),
    sourcePath: params.sourcePath,
  };

  try {
    const storage = getSessionStorage();
    if (!storage) return null;
    storage.setItem(START_PENDING_INVITE_STORAGE_KEY, JSON.stringify(snapshot));
    return snapshot;
  } catch {
    return null;
  }
}

export function readPendingStartInvite(): PendingStartInvite | null {
  try {
    const raw = getSessionStorage()?.getItem(START_PENDING_INVITE_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as Partial<PendingStartInvite>;
    const inviteCode = normalizeInviteCode(parsed.inviteCode);
    if (!inviteCode || typeof parsed.createdAt !== "string" || typeof parsed.sourcePath !== "string") {
      return null;
    }

    return {
      inviteCode,
      createdAt: parsed.createdAt,
      sourcePath: parsed.sourcePath,
    };
  } catch {
    return null;
  }
}

export function clearPendingStartInvite(): void {
  try {
    getSessionStorage()?.removeItem(START_PENDING_INVITE_STORAGE_KEY);
  } catch {
    // ignore unavailable storage
  }
}
